import React from 'react';
interface Props {
  eyebrow?: string;
  title: string;
  intro?: string;
  align?: 'left' | 'center';
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  align = 'left'
}: Props) {
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-224" data-mp="3f1vlng28wbeg">
      {eyebrow && <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-gold" data-id="element-225" data-mp="3k1865u5n96dv">{eyebrow}</p>}
      <h2 className="mt-3 font-display text-3xl leading-tight text-bone sm:text-4xl" data-id="element-226" data-mp="bletxricih2m">{title}</h2>
      <div className={`gold-rule mt-5 ${align === 'center' ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-227" data-mp="giey1wvmx9r3" />
      {intro && <p className="mt-5 text-[15px] leading-relaxed text-muted" data-id="element-228" data-mp="1tsjvyhquo1g">{intro}</p>}
    </div>;
}